const delivery = [
  {
    path: '/coupons',
    name: 'coupons.list',
    component: () => import('@/views/coupons/CouponList.vue'),
    meta: {
      env:['production'],
      pageTitle: 'Listar',
      roles: [1, 2, 5, 6],
      need_capability: 'coupons',
      breadcrumb: [
        {
          text: 'Cupons',
          active: true,
        },
      ],
    },
  },
]

export default delivery
